export interface EditSet {
  added: Set<string>
  removed: Set<string>
}

export function newEditSet(): EditSet {
  return { added: new Set(), removed: new Set() }
}
